import "./sentryInit"; // must precede React/App imports so Sentry patches fetch/XHR
import React from "react";
import ReactDOM from "react-dom";
import App from "./AppAdmin";
import { installClientLogger } from "./utils/clientLogger";
import { init, installGlobalHandlers, push, AuditErrorBoundary } from "@whalelo/audit-client";
import environments from "./environment";

installClientLogger();

const auditEndpoint =
	(environments.apiRoot || environments.localApiRoot || "http://localhost:3100/api") + "/audit/event";

init({
	app: "admin",
	endpoint: auditEndpoint,
});
installGlobalHandlers({ app: "admin", push });

ReactDOM.render(
	<AuditErrorBoundary
		app="admin"
		push={push}>
		<App />
	</AuditErrorBoundary>,
	document.getElementById("app")
);
// ReactDOM.hydrate(<App />, document.getElementById('app'));
